<template>
    <div v-if="visible" class="media-preview-wrapper" @click.self="handleClose">
        <div class="media-preview__canvas">
            <div class="media-preview__content" @click.stop>
                <!-- 视频预览 -->
                <div v-if="computedMediaType === 'video'" class="media-preview__video">
                    <video :src="mediaSrc" controls controlslist="nodownload"
                        style="max-height: 100%; max-width: 100%; width: auto; height: auto;" @click.stop></video>
                </div>
                <!-- 音频预览 -->
                <div v-else-if="computedMediaType === 'audio'" class="media-preview__audio">
                    <div class="audio-icon">
                        <i class="el-icon-headset" style="font-size: 64px; color: #409eff;"></i>
                    </div>
                    <audio :src="mediaSrc" controls controlslist="nodownload"
                        style="width: 100%; max-width: 500px; margin-top: 20px;" @click.stop></audio>
                </div>
                <!-- 媒体信息 -->
                <div class="media-preview__info">
                    <div class="media-name" :title="mediaName">
                        {{ mediaName }}
                    </div>
                    <el-button style="margin-top: 10px; font-size: 14px;" size="medium" icon="el-icon-download"
                        type="primary" @click="handleDownload">下载</el-button>
                </div>
                <!-- 关闭按钮 -->
                <div class="media-preview__close" @click="handleClose">
                    <i class="el-icon-close"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LookVideo',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        mediaSrc: {
            type: String,
            default: ''
        },
        mediaName: {
            type: String,
            default: ''
        }
    },
    computed: {
        // 根据 URL 后缀判断媒体类型
        computedMediaType() {
            if (!this.mediaSrc) return 'video'
            
            // 获取 URL 的后缀名（不包含查询参数）
            const url = this.mediaSrc.split('?')[0]
            const extension = url.split('.').pop().toLowerCase()
            
            // 音频文件扩展名
            const audioExtensions = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'wma']
            
            // 视频文件扩展名
            const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'wmv', 'flv', 'webm', 'm4v', '3gp']
            
            if (audioExtensions.includes(extension)) {
                return 'audio'
            } else if (videoExtensions.includes(extension)) {
                return 'video'
            }
            
            // 默认返回 video
            return 'video'
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                // 阻止背景滚动
                document.body.style.overflow = 'hidden'
            } else {
                // 恢复背景滚动
                document.body.style.overflow = ''
            }
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        },
        handleDownload() {
            this.$emit('download')
        }
    },
    beforeDestroy() {
        // 组件销毁时恢复背景滚动
        document.body.style.overflow = ''
    }
}
</script>

<style scoped>
.media-preview-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
}

.media-preview__canvas {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;
}

.media-preview__content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 90%;
    max-height: 90%;
    padding: 20px;
}

.media-preview__video {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 80%;
    max-height: 80%;
}

.media-preview__video video {
    max-width: 100%;
    max-height: 80vh;
    border-radius: 4px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.media-preview__audio {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    min-width: 400px;
}

.audio-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.media-preview__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    color: #fff;
    text-align: center;
}

.media-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 500px;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
}

.media-preview__close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #fff;
    font-size: 24px;
}

.media-preview__close:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
}
</style>




// WEBPACK FOOTER //
// src/components/common/lookvideo.vue